export default __webpack_public_path__ + "static/media/features-2 (2).f08a5500.jpg";